import {
  encodePubkey,
  makeAuthInfoBytes,
  makeSignDoc,
} from "@cosmjs/proto-signing";
import { encodeSecp256k1Pubkey } from "@cosmjs/amino";
import typeUrlMap from "./msgTypes";

export const createSignature = (signature, publicKey, publicKeyType) => ({
  signature: signature.toString("base64"),
  pub_key: {
    type: publicKeyType,
    value: publicKey.toString("base64"),
  },
});

export const rawTxtoJson = (rawTx) => {
  const tx = normalizeRawTx(rawTx);
  return JSON.stringify(tx);
};

export const normalizeRawTx = (msgObj) => {
  if (!msgObj) return msgObj;
  if (typeof msgObj !== "object") return msgObj;
  if (Array.isArray(msgObj)) {
    const out = [];
    msgObj.forEach((obj) => {
      out.push(normalizeRawTx(obj));
    });
    return out;
  }
  const out = {};
  const sortedKeys = Object.keys(msgObj).sort();
  sortedKeys.forEach((key) => {
    out[key] = normalizeRawTx(msgObj[key]);
  });
  return out;
};

export const aminoTxToSignDoc = (rawTx, stargateClient, accountPayload) => {
  const pubkey = encodePubkey(
    encodeSecp256k1Pubkey(accountPayload.pubkeyBytes)
  );
  pubkey.typeUrl = accountPayload.typeUrl;
  const txBodyEncodeObject = {
    typeUrl: "/cosmos.tx.v1beta1.TxBody",
    value: {
      messages: convertMesssages(rawTx.msgs),
      memo: rawTx.memo,
    },
  };

  const txBodyBytes = stargateClient.registry.encode(txBodyEncodeObject);
  const gasLimit = Number(rawTx.fee.gas);
  const sequence = Number(rawTx.sequence);
  const accountNumber = Number(rawTx.account_number);
  const chainId = rawTx.chain_id;

  const authInfoBytes = makeAuthInfoBytes(
    [{ pubkey, sequence }],
    rawTx.fee.amount,
    gasLimit
  );
  const signDoc = makeSignDoc(
    txBodyBytes,
    authInfoBytes,
    chainId,
    accountNumber
  );
  return { signDoc };
};

export const convertMesssages = (msgs = []) => {
  return msgs.map((msg) => ({
    typeUrl: typeUrlMap[msg.type],
    value: convertMsgFields(msg.value),
  }));
};

const convertMsgFields = (source) => {
  const dest = {};
  Object.keys(source).forEach((field) => {
    let value = source[field];
    if (
      "object" === typeof value &&
      !ArrayBuffer.isView(value) &&
      !Array.isArray(value)
    ) {
      value = convertMsgFields(value);
    }
    dest[snakeToCamel(field)] = value;
  });
  return dest;
};

const snakeToCamel = (field) => {
  const matches = field.match(/(_[a-z])/g);
  matches?.forEach((m) => {
    field = field.replace(m, m[1].toUpperCase());
  });
  return field;
};

export const getPubKeyStr = (pubkey) => {
  if (!pubkey) return "";
  if ("string" === typeof pubkey) return pubkey;
  return encodeSecp256k1Pubkey(pubkey);
};
